"use strict";
angular.module("robotQuickPreview", ["robotPrevDetailModule"]).
controller("robotQuickPreviewCtrl", ['$scope', 'storageListenerService', '$state', '$stateParams', '$timeout', 'trsHttpService', 'localStorageService', '$q', 'trsspliceString', '$filter', '$compile', 'resCtrModalService', 'globleParamsSet', function($scope, storageListenerService, $state, $stateParams, $timeout, trsHttpService, localStorageService, $q, trsspliceString, $filter, $compile, resCtrModalService, globleParamsSet) {
    initStatus();
    initData();
    /**
     * [initStatus description] 状态初始化
     */
    function initStatus() {
        decode($stateParams.nodename); //将路由上面的参数解码为汉字参数
        //初始化分页参数
        $scope.page = {
            "CURRPAGE": 1,
            "ITEMCOUNT": "",
            "PAGECOUNT": "",
            "PAGESIZE": 20,
        };
        $scope.jumpToPageNum = 1;
        //请求列表的参数,有一些写死的参数
        $scope.params = {
            "typeid": "zyzx",
            "serviceid": "robotNews",
            "modelid": "summary",
            "category": $scope.category,
            "title": "",
            "content": "",
            "page": "1",
            "pageSize": $scope.page.PAGESIZE,
            "time": "",
        };
        $scope.data = {
            items: [],
            operFlags: []
        };
        $scope.status = {
            searchShow: false, //是否显示搜索栏
            showRightDetail: false, //是否显示右侧详情
            curSelected: "" //当前选中的详情ID
        };
    }
    /**
     * [decode description] 将路由上面的参数解码为汉字参数
     * @param  {[type]} node [description]
     * @return {[type]}      [description]
     */
    function decode(nodename) {
        var reg = /[\u4e00-\u9fa5]+/;
        if (reg.test(nodename) || nodename == 'CPI' || nodename == 'GDP') {
            $scope.category = nodename;
        } else {
            nodename = decodeURI(nodename);
            decode(nodename);
        }
    }
    /**
     * [initDropDown description] 初始化搜索下拉框
     * @return {[type]} [description]
     */
    function initDropDown() {
        var deferred = $q.defer();
        $scope.data.robotAll = [{
            name: "全部",
            value: "all"
        }, {
            name: "标题",
            value: "title"
        }, {
            name: "正文",
            value: "content"
        }];
        $scope.data.robotSelected = angular.copy($scope.data.robotAll[0]);
        deferred.resolve();
        return deferred.promise;
    }
    /**
     * [initData description] 数据初始化
     */
    function initData() {
        listenStorage();
        initDropDown().then(function() {
            if (angular.isDefined($scope.$root.filterData)) { //判断是否有传递的数据
                var filterData = angular.copy($scope.$root.filterData);
                //$timeout(function() {
                    $scope.page = filterData.page;
                    $scope.params.page = $scope.page.CURRPAGE;
                    $scope.params.pageSize = $scope.page.PAGESIZE;
                    $scope.keywords = filterData.keywords;
                    $scope.params.title = filterData.paramsTitle;
                    $scope.params.content = filterData.paramsContent;
                    if (angular.isDefined(filterData.fromdate)) { //时间下拉选择
                        $scope.data.fromdate = angular.copy(filterData.fromdate);
                        $scope.data.untildate = angular.copy(filterData.untildate);
                        $scope.params.time = $scope.data.fromdate + ',' + $scope.data.untildate;
                    }
                    if (!!$scope.keywords) { //当前检索词
                        $scope.status.searchShow = true;
                        if ($scope.params.title != "" && $scope.params.content != "") {
                            $scope.data.robotSelected = angular.copy($scope.data.robotAll[0]);
                        } else if ($scope.params.title != "") {
                            $scope.data.robotSelected = angular.copy($scope.data.robotAll[1]);
                        } else {
                            $scope.data.robotSelected = angular.copy($scope.data.robotAll[2]);
                        }
                    }
                    //getFilterDataBack();
                    requestData();
                //}, 0);
            } else {
                requestData();
            }
        });
        $scope.$on("$destroy", function() {
            delete $scope.$root.filterData;
        });
    }
    /**
     * [listenStorage description]监听本地缓存
     * @return {[promise]} [description] promise
     */
    function listenStorage() {
        storageListenerService.listenResource(function() {
            requestData();
            storageListenerService.removeListener("resource");
        }, $scope);
    }
    /**
     * [getFilterDataBack description]获取跳转回普通视图存储信息
     * @return {[type]} [description]
     */
    function getFilterDataBack() {

        $scope.$root.filterDataBack = {
            page: $scope.page, //分页
            keywords: $scope.keywords, //检索词
            paramsTitle: $scope.params.title,
            paramsContent: $scope.params.content,
            //fromdate: $scope.data.fromdate, //开始时间
            //untildate: $scope.data.untildate, //结束时间
        };
        if ($scope.data.fromdate != '') {
            $scope.$root.filterDataBack.fromdate = $scope.data.fromdate; //开始时间
            $scope.$root.filterDataBack.untildate = $scope.data.untildate; //结束时间
        }
    }
    /**
     * [requestData description] 请求数据
     * @return {[type]} [description]
     */
    function requestData() {
        $scope.params.time = $scope.params.time == "," ? '' : $scope.params.time;
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
            $scope.data.items = data.content;
            if ($state.params.guid) {
                showDetail({ nid: $state.params.guid });
            } else if ($scope.data.items.length > 0) { //默认显示第一篇详情
                showDetail($scope.data.items[0]);
            }
            $scope.page.ITEMCOUNT = data.summary_info.recordCount;
            storageListenerService.previewPageTurningStorage($scope.data.items, "nid", "resourceDetail");
            initOperFlag();
            //存储返回的检索信息
            getFilterDataBack();
        });
    }
    /**
     * [queryByDropdown description] test筛选条件触发后请求数据(时间下拉)
     * @param  {[type]} key   [description] 请求对象参数key
     * @param  {[type]} value [description] 请求对象值
     * @return {[type]}       [description] null
     */

    $scope.queryByDropdown = function(key, value) {
        $scope.params[key] = value;
        if (key == 'OperTime') {
            $scope.params.time = $scope.data.fromdate + ',' + $scope.data.untildate;
        }
        $scope.data.items = [];
        $scope.keywords = ""; //清空检索词
        $scope.params.title = $scope.params.content = '';
        delete $state.params.guid;
        requestData();
    };
    /**
     * [initOperFlag description] 初始化取签见撤重
     */
    function initOperFlag() {
        var docIds = trsspliceString.spliceString($scope.data.items, "nid", ",");
        if (docIds) {
            var params = {
                methodname: "queryFlag",
                serviceid: "mlf_bigdataexchange",
                guids: docIds
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                $scope.data.operFlags = [];
                var temp = data;
                for (var i in temp) {
                    if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf("1") > -1) {
                        $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                    }
                }
            });
        }
    }
    /**
     * [showOperFlag description] 显示取签见撤重标志
     * @param  {[type]} guid      [description]
     * @param  {[type]} flagIndex [description]
     * @return {[type]}           [description]
     */
    $scope.showOperFlag = function(guid, flagIndex) {
        var temp = queryItemBYGUID(guid);
        if (!!temp) {
            return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == "1" ? true : false;
        } else {
            return false;
        }
    };

    /**
     * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
     * @param  {[type]} guid [description]
     * @return {[type]}      [description]
     */
    function queryItemBYGUID(guid) {
        for (var i in $scope.data.operFlags) {
            if (guid == $scope.data.operFlags[i].GUID) {
                return $scope.data.operFlags[i];
            }
        }
    }

    /**
     * @param  {[type]} ChnlDocId  [description] 取签见撤重 点击弹出
     * @param  {[type]} showRepeat [description]
     * @return {[type]}            [description]
     */
    $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick, $event) {
        var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
        var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
        event.stopPropagation();
    };
    /**
     * [showTitle description] 鼠标移上去后的标题显示
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    /*$scope.showTitle = function(item) {
        var title = item.DOCTITLE.replace(/\<\/?font(.*?)\>/g, "");
        return title;
    };*/
    /**
     * [showTime description] 调整时间的显示格式
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.showTime = function(item) {
        var date = new Date(Date.parse(item.updatetime));
        return $filter("date")(date, "yyyy-MM-dd HH:mm").toString();
    };
    /**
     * [fullTextSearch description;全文检索]
     * @param  {[type]} ev [description:按下回车也能提交]
     */
    $scope.fullTextSearch = function(ev) {
        if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
            if ($scope.data.robotSelected.value == "title") {
                $scope.params.title = $scope.keywords;
                $scope.params.content = "";
            } else if ($scope.data.robotSelected.value == "content") {
                $scope.params.title = "";
                $scope.params.content = $scope.keywords;
            } else {
                $scope.params.title = $scope.keywords;
                $scope.params.content = $scope.keywords;
            }
            $scope.page.CURRPAGE = 1;
            $scope.params.page = $scope.page.CURRPAGE;
            delete $state.params.guid;
            requestData();
        }
    };
    /**
     * [getFilterTimeVal description]检索下拉框回调
     * @return {[type]} [description]
     */
    $scope.getFilterVal = function() {
        console.log($scope.data.robotSelected);
    };
    /**
     * [isShowSearch description]显示隐藏检索条件
     * @return {Boolean} [description]
     */
    $scope.isShowSearch = function() {
        $scope.status.searchShow = !$scope.status.searchShow;
        //隐藏清空？
        //
    };
    /**
     * [pageChanged description] 分页
     * @return {[type]} [description]
     */
    $scope.pageChanged = function() {
        $scope.params.page = $scope.page.CURRPAGE;
        $scope.jumpToPageNum = $scope.page.CURRPAGE;
        delete $state.params.guid;
        requestData();
    };
    /**
     * [showDetail description]展示详情
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    $scope.showDetail = function(item) {
        showDetail(item);
    };
    /**
     * [showDetail description]展示详情 
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    function showDetail(item) {
        $scope.status.showRightDetail = false;
        $state.params.guid = item.nid;
        $state.go($state.current.name, $state.params, { reload: false });
        $scope.data.rebuildData = {
            nid: item.nid,
        };
        $timeout(function() {
            $scope.status.curSelected = item.nid;
            $scope.status.showRightDetail = true;
        }, 0);
    }
    /**
     * [plainView description] 返回 普通视图
     * @return {[type]} [description]
     */
    $scope.plainView = function() {
        $state.go("front.networksource.featuredresource.robot.resource", $stateParams);
    };
}]);